// components/Layout/Sidebar.js
import { NavLink } from 'react-router-dom';
import {
  FaCut,
  FaTachometerAlt,
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaUsers,
  FaUserTie,
  FaBoxOpen,
  FaCog,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
    
  FaClipboardCheck,
  FaMoneyCheckAlt,
  FaChartLine,  

} from 'react-icons/fa';
import './Layout.css';

function Sidebar({ isOpen, closeSidebar, isCollapsed, toggleCollapse }) {
const navItems = [
  { to: '/dashboard', icon: <FaTachometerAlt />, label: 'Dashboard', end: true },
  { to: '/dashboard/appointments', icon: <FaCalendarAlt />, label: 'Appointments' },
  { to: '/dashboard/billing', icon: <FaFileInvoiceDollar />, label: 'Create Invoice' },
  { to: '/dashboard/invoices', icon: <FaFileInvoiceDollar />, label: 'Invoices' },
  // { to: '/dashboard/clients', icon: <FaUsers />, label: 'Clients' },
  { to: '/dashboard/staff', icon: <FaUserTie />, label: 'Staff' },
  { to: '/dashboard/attendance', icon: <FaClipboardCheck />, label: 'Attendance' },
  { to: '/dashboard/salary', icon: <FaMoneyCheckAlt />, label: 'Salary' },
  { to: '/dashboard/finance', icon: <FaChartLine />, label: 'Income / Expense' },
  { to: '/dashboard/services', icon: <FaBoxOpen />, label: 'Services' },
  { to: '/dashboard/settings', icon: <FaCog />, label: 'Settings' },
];

  return (
    <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="brand-row">
          <span className="brand-icon-box">
            <FaCut />
          </span>
          {!isCollapsed && <span className="brand-name">Glow & Style</span>}
        </div>

        <div className="sidebar-header-actions">
          <button
            className="sidebar-collapse-btn-top"
            onClick={toggleCollapse}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </button>
          <button className="sidebar-close-btn" onClick={closeSidebar}>
            <FaTimes />
          </button>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? 'active' : ''}`
            }
            onClick={closeSidebar}
            title={isCollapsed ? item.label : undefined}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {!isCollapsed && <span className="sidebar-label">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;